// Lightweight helpers for deciding whether a file is 3D-viewable. Kept free of any three.js import
// so CaseFilesPanel can reference it without pulling the (heavy) viewer + three into the main bundle
// — the viewer itself is lazy-loaded only when a model is opened.
import type { PatientMedia } from '@alignova/shared';

export const VIEWABLE_3D_EXTS = ['stl', 'obj', 'ply'] as const;

/** Lowercased extension without the dot, from the original filename (falls back to the stored path). */
export function extOf(media: Pick<PatientMedia, 'originalName' | 'filePath'>): string {
  const name = media.originalName ?? media.filePath;
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
}

export function is3DViewable(media: Pick<PatientMedia, 'originalName' | 'filePath'>): boolean {
  return (VIEWABLE_3D_EXTS as readonly string[]).includes(extOf(media));
}
